<template>
	<div class="card">
		<div v-if="$scopedSlots.base" @click="$emit('click', data)">
			<slot name="base"></slot>
		</div>
		<div v-else class="card-base-info flex" @click="$emit('click', data)">
			<div v-if="index" class="index flex-center" :style="{'background': `var(--color-${index.color || 'main'})`}">{{index.index}}</div>
			<div v-if="data.baseInfo.cover" class="cover" :style="{'background-image': `url('${data.baseInfo.cover}')`}" @click.stop="$preview({src: data.baseInfo.cover})"></div>
			<div class="flex-grow">
				<div v-if="$scopedSlots.base_state" class="state flex-wrap">
					<slot name="base_state"></slot>
				</div>
				<p v-if="data.baseInfo.title" class="title">{{data.baseInfo.title}}</p>
			</div>
			<div v-if="data.baseInfo.count" class="count flex-column flex-center">
				<div>{{data.baseInfo.count.value || '-'}}</div>
				<p>{{data.baseInfo.count.name}}</p>
			</div>
		</div>

		<div v-if="$scopedSlots.content" class="card-field-info" @click="$emit('click', data)">
			<slot name="content"></slot>
		</div>
		<div v-else class="card-field-info" @click="$emit('click', data)">
			<template v-for="(field, j) in fieldList">
				<template v-if="$scopedSlots[`${field.field_code}_custom`]">
					<div :key="j" class="item area">
						<slot :name="`${field.field_code}_custom`"></slot>
					</div>
				</template>

				<template v-else>
					<div :key="j" class="item flex">
						<i v-if="field.is_custom" class="icon tf-field-custom"></i>
						<i v-else class="icon tf-field"></i>
						<div class="content flex-grow flex-wrap">{{field.field_title}}：
							<template v-if="$scopedSlots[field.field_code]">
								<slot :name="field.field_code"></slot>
							</template>
							<template v-else-if="field.is_custom">
								<div v-if="['file', 'image'].includes(data.customFieldValues[field.field_code].config_json.type)" class="flex-grow flex-wrap file-list">
									<template v-if="data.customFieldValues[field.field_code].value">
										<template v-if="typeof data.customFieldValues[field.field_code].value == 'string'">
											<c-file v-for="(item, i) in data.customFieldValues[field.field_code].value.split(',')" :key="i" :src="item" media :preview="data.customFieldValues[field.field_code].value.split(',')" @click.native.stop></c-file>
										</template>
										<template v-else>
											<c-file v-for="(item, i) in data.customFieldValues[field.field_code].value" :key="i" :src="item" media :preview="data.customFieldValues[field.field_code].value" @click.native.stop></c-file>
										</template>
									</template>
								</div>
								<c-tags v-else-if="typeof data.customFieldValues[field.field_code].value == 'object'" :value="data.customFieldValues[field.field_code].value"></c-tags>
								<span v-else>{{data.customFieldValues[field.field_code].value || '-'}}</span>
							</template>
							<template v-else>{{data[field.field_code] || '-'}}</template>
						</div>
					</div>
				</template>
			</template>
		</div>
		<slot v-if="$slots.bar" name="bar"></slot>
		<div v-if="$slots.operate" class="card-button flex-end-center flex-wrap">
			<slot name="operate"></slot>
		</div>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'viewListCard',

		props: {
			data: Object,
			index: [Object, Boolean]
		},

		data() {
			return {
				...getStore(this, 'viewStore')
			}
		},
		
		computed: {
			...mapStore('viewStore', ['fieldList'])
		}
	}
</script>

<style lang="stylus" scoped>
	.card {
		position: relative;
		border-radius: .16rem;
		padding: .24rem;
		margin: 0 .24rem;
		background: #fff;

		&-base-info {
			margin-bottom: .2rem;

			.index {
				box-sizing: border-box;
				min-width: .4rem;
				height: .4rem;
				padding: 0 .1rem;
				border-radius: .2rem;
				margin-right: .14rem;
				margin-top: -.02rem;
				font-size: .28rem;
				font-style: italic;
				text-align: center;
				color: #fff;
			}

			.cover {
				width: 1.48rem;
				height: 1.48rem;
				border-radius: .08rem;
				margin-right: .16rem;
				background-size: cover;
				background-position: center;
			}

			.state {
				gap: .1rem;

				+ .title {
					margin-top: .16rem;
				}
			}

			.title {
				line-height: .44rem;
				font-size: .32rem;
				word-break: break-word;
			}

			.count {
				box-sizing: border-box;
				min-width: 1.5rem;
				height: .92rem;
				border: .01rem dashed #ddd;
				border-radius: .04rem;
				padding: 0 .14rem;
				margin-left: .24rem;
				font-size: .24rem;
				color: #777;
				background: #F9F9F9;

				div {
					margin-bottom: .1rem;
					font-size: .34rem;
					font-weight: 500;
					color: #FF0101;
				}
			}
		}

		&-field-info {
			>>> .c-field {
				line-height: .38rem;
				font-size: .26rem;
				color: #91A1B9;

				&:nth-child(n+2) {
					margin-top: .06rem;
				}
			}

			.item {
				line-height: .38rem;
				font-size: .26rem;
				word-break: break-word;
				color: #666;

				&:nth-child(n+2) {
					margin-top: .06rem;
				}

				.icon {
					margin-right: .15rem;
				}

				.content {
					gap: .1rem;

					> .c-progress {
						flex-grow: 1;
						width: auto !important;
					}
				}
			}

			.area {
				border-radius: .08rem;
				overflow: hidden;
				background: #F9F9F9;

				&:nth-child(n+2) {
					margin-top: .08rem;
				}

				&:nth-last-child(n+2) {
					margin-bottom: .1rem;
				}
			}

			.file-list {
				gap: .1rem;
				
				>>> .c-file-media {
					width: .8rem;
					height: .8rem;
				}
			}
		}

		&-bar {
			gap: .45rem;
			height: 1.2rem;
			border-radius: .08rem;
			padding: 0 .15rem 0 .3rem;
			margin-top: .2rem;
			background: #F9F9F9;

			&-total {
				gap: .1rem;
				font-size: .26rem;
				color: #666;
				
				strong {
					font-size: .28rem;
					color: #000;
				}
			}
		}

		&-button {
			gap: .2rem;
			margin-top: .2rem;
		}
	}
</style>
